import React from 'react'
import "./CustomerFormStyle.css";
import { BsPlayCircleFill } from "react-icons/bs";



export default function VideoContainer({ setIsModalVisible, videoTitle,thumbnail }) {
  return (
    <div className="VideoContainer">
      <div onClick={() => setIsModalVisible(true)}>
      <img
          alt=""
          src={
            thumbnail
              }
                      
              style={{
                width: "90%",
                height : "100%",
                borderRadius : 10                      // border:"1px solid red"
              }}
                    />
        <div className="playContainer">
          <div className="otpTime">
            <p
              style={{
                fontSize: "16px",
                color: "#000000",
                fontWeight: "500",
              }}
            >
              {videoTitle}
            </p>
            <p
              style={{
                fontSize: "14px",
                color: "#747474",
                fontWeight: "400",
              }}
            >
            3 min watch 
            </p>
          </div>
          <div className="playBtn">
            <BsPlayCircleFill
              style={{
                color: "white",
                fontSize: "15px",
                marginRight: "5px",
              }}
            />
            Play
          </div>
        </div>
      </div>
    </div>
  );
}
